import React from 'react'
import tv from '../../../assets/images/tv-sketch.svg'
import {reviews} from '../../../data/reviews'

function Reviews() {
	return (
		<section className="bg-bg-white w-full bg-cover overflow-hidden object-cover">
			<div className="container mx-auto py-[64px] md:py-[100px]">
				<div className="flex items-center flex-col">
					<div className="flex items-center justify-center">
						<h3 className="font-sfprobold md:text-5xl text-[28px] font-bold md:pr-8 pr-5">Client's reviews</h3>
						<img src={tv} className="md:h-[76px] md:w-[76px] h-[44px] w-[44px] object-cover pointer-events-none" alt="Pin" />
					</div>
				</div>
				<div className='md:w-full w-11/12 mx-auto mt-14 md:grid md:grid-cols-3 items-center gap-8 flex flex-col'>
					{reviews.map((review, i) => (
					<div className="md:p-8 p-5 md:rounded-[20px] rounded-[8px] bg-white min-h-[300px] relative" key={i}>
						<h3 className="font-sfprobold font-extrabold text-base leading-6">{review.review}</h3>
						<div className='flex items-center bottom-8 absolute'>
							<div className="h-[50px] w-[50px] border-2 border-black rounded-[50%] overflow-hidden">
									<img src={review.image} alt="User" className="h-full w-full object-cover pointer-events-none" />
							</div>
							<div className="pl-4">
								<h3 className="font-sfprobold font-bold text-sm pb-2">{review.name}</h3>
									<p className="font-sfpro font-normal text-sm opacity-70">{review.role}</p>
							</div>
						</div>
						</div>
					))}
				</div>

			</div>
		</section>
	)
}

export default Reviews